import { ValidatorExpr } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import { ExternalResources, ValidationResult } from "../../core/types";
import { getExpressionResolver } from "../../expressions/registry";

export const templateFieldValidator =
  (
    value: unknown,
    getValue: (key: string) => unknown,
    externalResources?: ExternalResources
  ) =>
  async (validationExpr: ValidatorExpr): Promise<ValidationResult> => {
    // Use function instead of type for the new API
    const funcName = validationExpr.function;

    const expressionResolver = getExpressionResolver(funcName);

    if (!expressionResolver) {
      console.error(
        `[FormEngine:templateFieldValidator] No resolver found for expression function: ${funcName}`
      );
      return false;
    }

    try {
      const result = await expressionResolver({
        fieldValue: value,
        expression: validationExpr,
        templateFieldValueResolver: getValue,
        externalResources,
      });

      const errorMessage = validationExpr.errorMessage
        ? validationExpr.errorMessage
        : "Invalid value";
      return result ? Boolean(result) : errorMessage;
    } catch (error) {
      console.warn("Error resolving validation expression:", error);
      // On error, default to invalid (assume falsy)
      const errorMessage = validationExpr.errorMessage
        ? validationExpr.errorMessage
        : "Validation error";
      return errorMessage;
    }
  };
